// Company branding configuration - update these values to rebrand the application
export const COMPANY_NAME = 'Link';
export const COMPANY_FULL_NAME = 'Link Home Care';
export const COMPANY_ADDRESS = '103-15 101st St, Ozone Park, NY 11417';
